import Collapsible from '@/components/Collapsible';
import { formatCurrency, formatRelativeTime } from '@/utils/formatUtils';
import { useTranslation } from 'react-i18next';
import avatarIcon from '@/assets/avatar.svg'
import dondonGrey from '@/assets/dondon_grey.svg'
import { getAvatarThumbnailUrl } from '@/utils/imageUtils';

const RecentPurchasesSection = ({ purchases = [], salesVolume }) => {
  const { t } = useTranslation();
  
  // Use salesVolume from API if available, otherwise fall back to purchases array length
  const totalCount = salesVolume ?? purchases.length;
  const purchasesCount = totalCount === 0 
    ? '' 
    : totalCount > 9000 
      ? `(${totalCount}+)` 
      : `(${totalCount})`;

  return (
    <Collapsible 
      title={
        <div className="flex items-center gap-2">
          <span>{t('card.recent_purchases')}</span>
          <span className="text-sm text-[#aaaaaa]">{purchasesCount}</span>
        </div>
      }
      defaultOpen
      className="mt-8 border-0 rounded-none border-t"
    >
      {purchases.length > 0 ? (
        <div className="max-h-[264px] px-4 bg-white rounded-md border border-[#eeeeee] overflow-y-auto">
          {purchases.map((purchase, index) => (
            <div 
              key={index}
              className={`h-12 flex items-center gap-2 ${
                index !== purchases.length - 1 ? 'border-b border-[#f4f4f4]' : ''
              }`}
            >
              <div className="flex-1 flex items-center h-6">
                <div className="flex items-center min-w-0 flex-1">
                  <img 
                    src={getAvatarThumbnailUrl(purchase.buyer?.avatar?.url) || avatarIcon} 
                    alt="User" 
                    className="w-6 h-6 rounded-[999px] mr-2" 
                  />
                  <span className="text-sm text-[#aaaaaa] text-left leading-[21px] truncate">
                    {formatRelativeTime(purchase.createdAt, t)}
                  </span>
                </div>
                <div className="flex-1 text-sm text-[#111111] text-center leading-[21px]">
                  {(() => {
                    // PSA grade display
                    if (purchase.listing?.psa) {
                      return purchase.listing.psa.replace('PSA_', 'PSA ');
                    }
                    // BOX quantity display
                    if (purchase.listing?.bundledQuantity) {
                      return `${purchase.listing.bundledQuantity} ${purchase.listing.boxType === 'PACK' ? t('box.pack') : t('box.box_unit')}`;
                    }
                    // Condition display for non-PSA cards
                    if (purchase.listing?.condition) {
                      return t(`sell.product_info.conditions.${purchase.listing.condition.toLowerCase()}`);
                    }
                    // Fallback to type or dash
                    return purchase.listing?.type || "-";
                  })()}
                </div>
                <div className="flex-1 text-sm text-[#111111] text-right leading-[21px]">
                  {formatCurrency(purchase.price)}
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="h-[200px] flex flex-col items-center justify-center bg-white rounded-md border border-[#eeeeee]">
          <img src={dondonGrey} alt="DonDon" className="w-[120px] h-[80px] mb-4" />
          <p className="text-sm text-[#aaaaaa]">{t('common.no_purchase_records')}</p>
        </div>
      )}
    </Collapsible>
  );
};

export default RecentPurchasesSection; 
